module.exports = __webpack_public_path__ + "static/fonts/Fact-ThinItalic.6bea33a.eot";